import { Component } from '@angular/core';

@Component({
  selector: 'app-technical-foundations',
  templateUrl: './technical-foundations.component.html',
  styleUrls: ['./technical-foundations.component.css']
})
export class TechnicalFoundationsComponent {

}
